export const APP_WORKSPACE_STATUS = {
  PUBLISHED: "published",
  COMING_SOON: "coming_soon",
};

export const APP_WORKSPACE_MODEL_TYPE = {
  STANDARD: "standard",
  AI_POWERED: "ai_powered",
  PERLAB_PARAMETRIC: "perlab_parametric",
};

export const APP_WORKSPACE_TOWERS = [
  {
    id: "mechanical",
    title: "Mechanical",
    route: "/mechanical",
    color: "#667eea",
    commodities: [
      {
        name: "Plastics",
        description: "Injection molding, extrusion, thermoforming",
        icon: "/images/Commodities/Plastics.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC,
      },
      {
        name: "Sheet Metal",
        description: "Stamping, bending, laser cutting",
        icon: "/images/Commodities/SheetMetal.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC,
      },
      {
        name: "Casting & Machining",
        description: "Die casting, CNC machining, milling",
        icon: "/images/Commodities/Casting&Machining.jpg",
        hasAI: true,
        modelType: APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
      },
      {
        name: "Forging",
        description: "Hot forging, cold forging, drop forging",
        icon: "/images/Commodities/Forging.jpg",
        hasAI: true,
        modelType: APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
      },
      {
        name: "Plastics",
        description: "Injection molding, extrusion, thermoforming",
        icon: "/images/Commodities/Plastics.jpg",
        hasAI: true,
        modelType: APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
      },
      {
        name: "Sheet Metal",
        description: "Stamping, bending, laser cutting",
        icon: "/images/Commodities/SheetMetal.jpg",
        hasAI: true,
        modelType: APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
      },
    ],
  },
  {
    id: "electronics",
    title: "Electronics",
    route: "/electronics",
    color: "#f5576c",
    commodities: [
      {
        name: "PCB",
        description: "Printed circuit boards, assembly",
        icon: "/images/Commodities/PCB.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
    ],
  },
  {
    id: "packaging",
    title: "Packaging",
    route: "/packaging",
    color: "#4facfe",
    commodities: [
      {
        name: "Corrugated",
        description: "Boxes, cartons, shipping materials",
        icon: "/images/Commodities/Corrugated.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Bottles",
        description: "PET, glass, plastic containers",
        icon: "/images/Commodities/Bottles.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Laminates",
        description: "Flexible packaging, pouches",
        icon: "/images/Commodities/Lamintaes.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
    ],
  },
  {
    id: "fnb",
    title: "F&B",
    route: "/fnb",
    color: "#43e97b",
    commodities: [
      {
        name: "Cookies",
        description: "Biscuits, crackers, wafers",
        icon: "/images/Commodities/Cookies.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Ice Creams",
        description: "Frozen desserts, novelties",
        icon: "/images/Commodities/Icecreams.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Carbonated Drinks",
        description: "Soft drinks, sodas, sparkling water",
        icon: "/images/Commodities/CarbonatedDrinks.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Meat",
        description: "Processed meat, sausages, patties",
        icon: "/images/Commodities/Meat.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
    ],
  },
  {
    id: "bpch",
    title: "BPCH",
    route: "/bpch",
    color: "#fa709a",
    commodities: [
      {
        name: "Shampoo",
        description: "Hair care, cleansers, conditioners",
        icon: "/images/Commodities/Shampoos.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Face Serum",
        description: "Anti-aging, moisturizers, treatments",
        icon: "/images/Commodities/Face Serum.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Perfume",
        description: "Fragrances, eau de toilette, cologne",
        icon: "/images/Commodities/Perfume.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Body Lotion",
        description: "Moisturizers, creams, butters",
        icon: "/images/Commodities/BodyLotion.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
      {
        name: "Bar Soap",
        description: "Bath soap, hand soap, beauty bars",
        icon: "/images/Commodities/barSoap.jpg",
        modelType: APP_WORKSPACE_MODEL_TYPE.STANDARD,
      },
    ],
  },
];

export const MECHANICAL_COMMODITY_ORDER = [
  "Plastics",
  "Sheet Metal",
  "Casting & Machining",
  "Forging",
];

export function getWorkspaceItemKey(tower, commodity, modelType = APP_WORKSPACE_MODEL_TYPE.STANDARD) {
  return `${String(tower || "").trim().toLowerCase()}::${String(commodity || "")
    .trim()
    .toLowerCase()}::${String(modelType || APP_WORKSPACE_MODEL_TYPE.STANDARD)
    .trim()
    .toLowerCase()}`;
}

export function normalizeWorkspaceStatus(status) {
  return status === APP_WORKSPACE_STATUS.COMING_SOON
    ? APP_WORKSPACE_STATUS.COMING_SOON
    : APP_WORKSPACE_STATUS.PUBLISHED;
}

export function buildWorkspaceStatusMap(statuses = []) {
  return (statuses || []).reduce((accumulator, item) => {
    const key = getWorkspaceItemKey(item.tower, item.commodity, item.model_type);
    accumulator[key] = normalizeWorkspaceStatus(item.status);
    return accumulator;
  }, {});
}

export function getWorkspaceItemStatus(
  statusMap,
  tower,
  commodity,
  modelType = APP_WORKSPACE_MODEL_TYPE.STANDARD,
) {
  const key = getWorkspaceItemKey(tower, commodity, modelType);
  return normalizeWorkspaceStatus(statusMap?.[key]);
}

export function isWorkspaceItemPublished(
  statusMap,
  tower,
  commodity,
  modelType = APP_WORKSPACE_MODEL_TYPE.STANDARD,
) {
  return (
    getWorkspaceItemStatus(statusMap, tower, commodity, modelType) ===
    APP_WORKSPACE_STATUS.PUBLISHED
  );
}

export function getCommodityModelTabType(commodityOrModelType) {
  const modelType =
    typeof commodityOrModelType === "object" && commodityOrModelType !== null
      ? commodityOrModelType.modelType
      : commodityOrModelType;

  return modelType === APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC
    ? APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC
    : APP_WORKSPACE_MODEL_TYPE.AI_POWERED;
}

export function isPerlabParametricCommodity(commodity) {
  return getCommodityModelTabType(commodity) === APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC;
}

export function getTowerModelTabs(commodities = []) {
  const hasAiPoweredModel = (commodities || []).some(
    (commodity) => getCommodityModelTabType(commodity) === APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
  );
  const hasPerlabParametricModel = (commodities || []).some(
    (commodity) =>
      getCommodityModelTabType(commodity) === APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC,
  );
  const tabs = [];

  if (hasAiPoweredModel) {
    tabs.push({
      id: APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
      label: "AI Powered Model",
    });
  }

  if (hasPerlabParametricModel) {
    tabs.push({
      id: APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC,
      label: "Perlab Parametric Model",
    });
  }

  return tabs;
}

export function getDefaultTowerModelTab(commodities = []) {
  const towerModelTabs = getTowerModelTabs(commodities);
  return (
    towerModelTabs.find((tab) => tab.id === APP_WORKSPACE_MODEL_TYPE.AI_POWERED)?.id ||
    towerModelTabs[0]?.id ||
    APP_WORKSPACE_MODEL_TYPE.AI_POWERED
  );
}

export function filterCommoditiesByModelTab(
  commodities = [],
  modelTab = APP_WORKSPACE_MODEL_TYPE.AI_POWERED,
) {
  return (commodities || []).filter(
    (commodity) => getCommodityModelTabType(commodity) === modelTab,
  );
}

export function getWorkspaceModelLabel(modelType) {
  switch (modelType) {
    case APP_WORKSPACE_MODEL_TYPE.AI_POWERED:
      return "AI Powered Model";
    case APP_WORKSPACE_MODEL_TYPE.PERLAB_PARAMETRIC:
      return "Perlab Parametric Model";
    default:
      return "AI Powered Model";
  }
}

export function getAllWorkspaceItems() {
  return APP_WORKSPACE_TOWERS.flatMap((tower) =>
    tower.commodities.map((commodity, index) => ({
      id: `${tower.id}-${commodity.name}-${commodity.modelType || APP_WORKSPACE_MODEL_TYPE.STANDARD}-${index}`,
      towerId: tower.id,
      towerTitle: tower.title,
      towerRoute: tower.route,
      commodityName: commodity.name,
      modelType: commodity.modelType || APP_WORKSPACE_MODEL_TYPE.STANDARD,
      modelLabel: getWorkspaceModelLabel(
        commodity.modelType || APP_WORKSPACE_MODEL_TYPE.STANDARD,
      ),
      description: commodity.description,
      icon: commodity.icon,
    })),
  );
}

export function getTowerConfigById(towerId) {
  return APP_WORKSPACE_TOWERS.find((tower) => tower.id === towerId) || null;
}

